module.exports = __webpack_public_path__ + "static/media/img-5.cfab12f0.jpg";